//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAccountOperator } from "../../scripts/AccountOperator";
import AdminLinks from "./AdminLinks";
import ChartOverview from "../chartoverview/ChartOverview";
import MintGUI from "../mintgui/MintGUI";
import AlchmizerGUI from "../alchmizergui/AlchmizerGUI";
import AlchmizerBatches from "../alchmizerbatches/AlchmizerBatches";
import AlchmizerOutputs from "../alchmizeroutputs/AlchmizerOutputs";

import shadow_avatar from '../../image/team-image-3.webp'

import "./adminconsole.css";









//--------------------------------------------------------------------------------------------------
//# Variables

const Option1 = () => <AdminLinks />;
const Option2 = () => <AlchmizerGUI />;
const Option3 = () => <AlchmizerBatches />;
const Option4 = () => <ChartOverview />;
const Option5 = () => <AdminLinks />;

const PANEL_CONFIG = [
  { id: "option1", label: "Home", Component: Option1 },
  { id: "option2", label: "Alchmizer GUI", Component: Option2 },
  { id: "option3", label: "Alchmizer Outputs", Component: Option3 },
  { id: "option4", label: "Chart", Component: Option4 },
  { id: "option5", label: "Links", Component: Option5 },
];

//AppStart
const AdminConsole = () => {
  const [activePanelId, setActivePanelId] = useState(PANEL_CONFIG[0].id);
  const [isOpen, setIsOpen] = useState(false);
  // const navigate = useNavigate();
  // const { pathname } = useLocation();
  const { ready, authenticated, user, backendUser } = useAccountOperator();

  const avatar_URL = backendUser?.avatar_URL;

  const activePanel =
    PANEL_CONFIG.find((panel) => panel.id === activePanelId) || PANEL_CONFIG[0];

  const ActiveComponent = activePanel.Component;

  const handleSelect = (id) => {
    setActivePanelId(id);
    setIsOpen(false);
  };






//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className="adminConsole">

      {/* Admin Navbar */}
      <div className="adminConsoleNavbar">
        <div className="adminConsoleNavbarLeft">
          <div className="adminConsoleSelectContainer">
            <button className="adminConsoleSelectButton" type="button" onClick={() => setIsOpen((prev) => !prev)}>
              <span>{activePanel.label}</span>
              <span className="adminConsoleSelectCaret">▼</span>
            </button>
            {isOpen && (
              <ul className="adminConsoleDropdownMenu">
                {PANEL_CONFIG.map((panel) => (
                  <li
                    key={panel.id}
                    className={
                      panel.id === activePanelId
                        ? "adminConsoleDropdownItemActive"
                        : "adminConsoleDropdownItem"
                    }
                    onClick={() => handleSelect(panel.id)}
                  >
                    {panel.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Admin Main Console */}
      <main className="adminConsoleMain">
        <ActiveComponent />
      </main>
    </div>
  );
};

export default AdminConsole;